<template>
  <VContainer fluid grid-list-md>
    <VLayout wrap>
      <VFlex xs12 title font-weight-bold>Agenda</VFlex>
      <VFlex xs12>
        <VSelect hide-details color="primary" :items="tiposAgenda" solo v-model="tipoAgenda"/>
      </VFlex>
      <VFlex xs12>
        <VDivider class="my-2"/>
        <h1 class="title font-weight-bold">Filtros</h1>
        <VForm ref="form" lazy-validation>
          <VTextField label="Cliente" v-model="selecionarClientes" placeholder="Pesquisar por cliente"/>
          <VAutocomplete
            v-model="selecionarProfissionais" :items="listaProfissionais" attach chips
            label="Profissionais"
            placeholder="Filtrar por profissionais"
            multiple>
            <template v-slot:selection="data">
              <VChip :selected="data.selected" close class="chip--select-multi"
                     @input="removerProfissional(data.item)">
                {{ data.item }}
              </VChip>
            </template>
          </VAutocomplete>
          <VAutocomplete
            v-model="selecionarServicos" :items="listaServicos" attach chips
            label="Serviços" placeholder="Filtrar por serviços"
            multiple>
            <template v-slot:selection="data">
              <VChip :selected="data.selected" close class="chip--select-multi"
                     @input="removerServico(data.item)">
                {{ data.item }}
              </VChip>
            </template>
          </VAutocomplete>
          <VAutocomplete
            v-model="selecionarFuncoes" :items="listaFuncoes" attach chips
            label="Funções" placeholder="Filtrar por funções"
            item-text="nome"
            item-value="id"
            multiple>
            <template v-slot:selection="data">
              <VChip :selected="data.selected" close class="chip--select-multi"
                     @input="removerFuncao(data.item)">
                {{ data.item.nome }}
              </VChip>
            </template>
          </VAutocomplete>
        </VForm>
      </VFlex>
      <VFlex xs12 title font-weight-bold>
        <VDivider class="my-2"/>
        Comandas
        <VBtn
                color="primary"
                @click="novaComanda"
                style="min-width: 0px; max-width: 20px; max-height: 25px;"
        >
          <VIcon>add</VIcon>
        </VBtn>
        <VBtn
                color="primary"
                @click="acompanhamentoComandas"
                style="min-width: 0px; max-width: 20px; max-height: 25px;"
        >
          <VIcon>assignment</VIcon>
        </VBtn>
      </VFlex>
      <VFlex xs12>
        <VTextField
                v-model="searchComandas"
                label="Pesquisar"
                append-icon="search"
                single-line
                hide-details
                class="pt-0 mt-0"/>
      </VFlex>
      <VFlex xs12 style="height: 180px; overflow-y: auto;">
        <div v-for="comanda in filteredComandas" :key="comanda.id">
          <a @click="abrirComanda(comanda.id)">
            <VIcon v-if="comanda.cliente.aniversariante" color="primary" style="font-size: 1.3em">cake</VIcon>
            <VIcon v-else color="primary" style="font-size: 1.3em">star</VIcon>
            <span class="body-1">{{ comanda.name }}</span>
          </a>
        </div>
      </VFlex>
    </VLayout>
    <ReminderDialog v-model="isReminderDialogOpen"/>
    <ComandasAbertas v-model="comandasAbertas" ></ComandasAbertas>
  </VContainer>
</template>

<script>
import ReminderDialog from "@/components/Dialog/Lembrete";
import ApiService from "@/common/api.service";
import {mapState} from "vuex";
import eventos from '@/common/eventos';
import ComandasAbertas from "./Dialog/ComandasAbertas";
import * as mutations from '@/plugins/mutations.nomes';

export default {
  components: {
    ReminderDialog,
    ComandasAbertas,
  },
  data() {
    return {
      isReminderDialogOpen: false,
      comandasAbertas: false,
      searchComandas: "",
      comandas: [],
      selecionarFuncoes: [],
      selecionarServicos: [],
      selecionarClientes: '',
      selecionarProfissionais: [],
      dataSelecionada: [],
      tiposAgenda: [
        {text: "Avaliações", value: "avaliacoes"},
        {text: "Profissionais", value: "profissionais"},
        {text: "Espaços", value: "espacos"}
      ],
      tipoAgenda: 'profissionais'
    };
  },
  computed: {
    ...mapState([
      "dataAtual",
      "requisicoes",
      "listaProfissionais",
      "listaServicos",
      "listaFuncoes"]),
    filteredComandas() {
      if (this.searchComandas) {
        return this.comandas.filter(com => {
          return com.name.toLowerCase().includes(this.searchComandas.toLowerCase());
        });
      } else
        return this.comandas;
    },
  },
  created() {
    eventos.barramento.$on(eventos.COMANDA_ALTERADA, this.getComandas);
    eventos.barramento.$on(eventos.ATUALIZAR_TELA, this.atualizarTudo);
    this.dataSelecionada = this.dataAtual;
    this.getComandas();
  },
  watch: {
    dataAtual(data) {
      this.dataSelecionada = data;
    },
    dataSelecionada(data) {
      if (data !== this.dataAtual) 
        this.$store.commit(mutations.ALTERAR_DATA_ATUAL, data);
    },
    selecionarClientes(cliente) {
      this.$store.commit(mutations.FILTRAR_CLIENTES, cliente);
    },
    selecionarProfissionais(profissionais) {
      this.atualizarFiltroProfissionais(profissionais);
    },
    selecionarServicos(servicos) {
      this.atualizarFiltroServicos(servicos);
    },
    selecionarFuncoes(funcoes) {
      this.atualizarFiltroFuncoes(funcoes);
    },
    tipoAgenda(tipo) {
      this.$store.commit(mutations.ALTERAR_TIPO_AGENDA, tipo);
    }
  },
  methods: {
    async atualizarTudo(){
      await Promise.all([this.getComandas()]);
    },
    novaComanda() {
      eventos.barramento.$emit(eventos.ABRIR_DIALOG_COMANDA);
    },
    acompanhamentoComandas() {
      this.comandasAbertas = true;
    },
    verficarCliente(cliente) {
      return cliente ? `- ${cliente.nome}` : '';
    },
    abrirComanda(id) {
      eventos.barramento.$emit(eventos.ABRIR_DIALOG_COMANDA, {idComanda: id});
    },
    async getComandas() {
      this.comandas = (await ApiService.get('comandas')).data.map(e => {
        e.name = `${e.cliente.nome}${e.noiva ? ' 👰' : ''}`;
        return e;
      });
    },
    removerProfissional(item) {
      const index = this.selecionarProfissionais.indexOf(item);
      if (index >= 0) {
        this.selecionarProfissionais.splice(index, 1);
        this.atualizarFiltroProfissionais(this.selecionarProfissionais);
      }
    },
    removerServico(item) {
      const index = this.selecionarServicos.indexOf(item);
      if (index >= 0) {
        this.selecionarServicos.splice(index, 1);
        this.atualizarFiltroServicos(this.selecionarServicos);
      }
    },
    removerFuncao(item){
      const index = this.selecionarFuncoes.indexOf(item.id);
      if (index >= 0) {
        this.selecionarFuncoes.splice(index, 1);
        this.atualizarFiltroFuncoes(this.selecionarFuncoes);
      }
    },
    atualizarFiltroProfissionais(profissionais) {
      this.$store.commit(mutations.FILTRAR_PROFISSIONAIS, profissionais);
    },
    atualizarFiltroServicos(servicos) {
      this.$store.commit(mutations.FILTRAR_SERVICOS, servicos);
    },
    atualizarFiltroFuncoes(funcoes){
      this.$store.commit(mutations.FILTRAR_FUNCOES, funcoes);
    },
  }
};
</script>

<style>
.linx {
  color: #7030a0;
}

.topo {
  margin-top: -15px !important;
}
</style>
